export enum Input {
  // Details Section
  Image = 'image',
  Name = 'name',
  Parent = 'parent',
  Breed = 'breed',
  SizeCategory = 'size_category',
  CoatType = 'coat_type',
  DateOfBirth = 'date_of_birth',
  Gender = 'gender',

  // Medical Information Section
  Weight = 'weight',
  MicrochipNumber = 'microchip_number',
  Vet = 'vet',
  VetName = 'vet_name',
  VetPhone = 'vet_phone',
  Allergies = 'allergies',
  Vaccinated = 'vaccinated',
  MedicalNotes = 'medical_notes',

  // Notes Section
  GroomingPreferences = 'grooming_preferences',
  InternalNotes = 'internal_notes',
  Tags = 'tags',
  TagName = 'tag_name',
  TagColor = 'tag_color',
}
